import { QUEST_ACTION } from '../../constants/actions'

const changeQuestState = (property, value) => ({
  type: QUEST_ACTION.CHANGE_STATE,
  payload: {
    property,
    value
  }
})

const resetQuestState = () => ({
  type: QUEST_ACTION.RESET_STATE
})

const updateQuest = (id) => ({
  type: QUEST_ACTION.UPDATE_QUEST,
  payload: {
    id
  }
})

export { changeQuestState, resetQuestState, updateQuest }
